export default "__VITE_ASSET__BsJnDTVH__"